<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('SISTEMA.PROCURAR')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="is-flex is-justified-between">
                    <router-link
                        v-if="isInRole('condicaopagamento-alterar')"
                        :to="{ name: 'condicaopagamento' }"
                        class="button is-primary"
                        >
                        {{$t('SISTEMA.INCLUIR')}}
                    </router-link>
                </div>                
            </div>           

        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('SISTEMA.ID')" >
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Descricao" :label="$t('SISTEMA.DESC')" >
                    {{ props.row.descricao }}
                </b-table-column>

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link
                        v-if="isInRole('condicaopagamento-alterar')"
                        :to="{ name: 'condicaopagamento', params: { id: props.row.id }}"
                        class="button is-small is-primary"
                        :title="$t('SISTEMA.EDITAR')">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<script>
    import http from '@/http'
    import { mapGetters,mapState } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? '',
                ordenarPor: 'Descricao',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                   this.$t('SISTEMA.MANUTENCAO'),
                   this.$t('CONDICOESLISTA.CONDPAG'),
                ]
            },
            ...mapState([                                
                'unidadeId',                
            ]),               
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {            
            unidadeId: function() {                 
                this.loadAsyncData()                                                
            },
        },           
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`,
                    `unidadeId=${this.unidadeId}`,
                    `perPage=${this.perPage}`
                ].join('&')

                this.loading = true
                http.get(`/api/manutencao/condicoespagamentos?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {                
                this.$router.push({ name: 'condicaopagamento', params: {id: this.selecionado.id} });                                   
            },

        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>
